package top.wcpe.allincore.dsl.ir.model

import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedMap
import kotlin.jvm.JvmStatic

/**
 * UI DSL v2 model 地基。
 */
class UiModel(
    params: UiParams?,
    sessionNamespaces: Map<String, UiState>?,
    persistNamespaces: Map<String, UiState>?,
) {
    val params: UiParams = params ?: UiParams.empty()
    val sessionNamespaces: Map<String, UiState> = copyNamespaces(sessionNamespaces, "sessionNamespaces")
    val persistNamespaces: Map<String, UiState> = copyNamespaces(persistNamespaces, "persistNamespaces")

    fun isEmpty(): Boolean =
        params.isEmpty() && sessionNamespaces.isEmpty() && persistNamespaces.isEmpty()

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiModel) return false
        return params == other.params &&
            sessionNamespaces == other.sessionNamespaces &&
            persistNamespaces == other.persistNamespaces
    }

    override fun hashCode(): Int {
        var result = params.hashCode()
        result = 31 * result + sessionNamespaces.hashCode()
        result = 31 * result + persistNamespaces.hashCode()
        return result
    }

    override fun toString(): String =
        "UiModel(params=" + params +
            ", sessionNamespaces=" + sessionNamespaces +
            ", persistNamespaces=" + persistNamespaces + ")"

    companion object {
        private val EMPTY = UiModel(UiParams.empty(), emptyMap(), emptyMap())

        @JvmStatic
        fun empty(): UiModel = EMPTY

        private fun copyNamespaces(source: Map<String, UiState>?, label: String): Map<String, UiState> {
            val src = source ?: throw NullPointerException(label)
            val copied = LinkedHashMap<String, UiState>(src.size)
            for ((key, value) in src) {
                copied[key ?: throw NullPointerException(label + " key")] =
                    value ?: throw NullPointerException(label + " value")
            }
            return ReadOnlyOrderedMap(copied)
        }
    }
}
